/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.10
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CommonLimitOffsetPaginationResponse interface.
 */
export function instanceOfCommonLimitOffsetPaginationResponse(value) {
    if (!('total' in value) || value['total'] === undefined)
        return false;
    return true;
}
export function CommonLimitOffsetPaginationResponseFromJSON(json) {
    return CommonLimitOffsetPaginationResponseFromJSONTyped(json, false);
}
export function CommonLimitOffsetPaginationResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'total': json['total'],
    };
}
export function CommonLimitOffsetPaginationResponseToJSON(json) {
    return CommonLimitOffsetPaginationResponseToJSONTyped(json, false);
}
export function CommonLimitOffsetPaginationResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'total': value['total'],
    };
}
